"use client";
import React from "react";
import { WcAutoComplete, WcAutoCompleteProps } from "@bpipartners/webui";
import { Controller } from "react-hook-form";
type CustomAutoCompleteControllerProps = WcAutoCompleteProps<any> & {
  control: any;
  name: string;
  width?: string | number;
  customID?: string | number;
  fullObject?: boolean;
  onCustomChange?: (val: any) => void;
};

export const WcAutoCompleteController = ({
  name,
  control,
  customID,
  fullObject,
  multiple,
  onCustomChange,
  ...props
}: CustomAutoCompleteControllerProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value }, formState }) => (
      <WcAutoComplete
        defaultValue={props.defaultValue}
        onChange={(event, objectVal) => {
          if (multiple) {
            onChange(objectVal);
            if (onCustomChange) {
              onCustomChange(objectVal);
            }
          } else {
            if (customID) {
              onChange(objectVal[customID]);
            } else {
              if (objectVal && objectVal.id) {
                onChange(objectVal.id);
              }
            }

            if (onCustomChange) {
              if (fullObject) {
                onCustomChange(objectVal);
              } else {
                if (objectVal && objectVal.id) {
                  onChange(objectVal.id);
                }
              }
            }
          }
        }}
        // name={name}
        value={value}
        multiple={multiple}
        // control={control}
        {...props}
      />
    )}
  />
);
